import {Component, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {throwError} from 'rxjs';
//generic
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DynamicFormComponent} from 'app/core-ui/dynamic-form/containers/dynamic-form/dynamic-form.component';

//specific
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ApproveClientUploadRowComponent} from '../ApproveClientUploadRow/approveClientUploadRow.component';
import {NotificationBuilderService} from './notificationBuilder.service';

@Component({
  selector: 'notificationBuilder',
  templateUrl: './notificationBuilder.component.html',
  providers: [NotificationBuilderService],
})
export class NotificationBuilder extends BaseGridNoCookieComponent<NotificationBuilderService> {
  @ViewChild(DynamicFormComponent, {static: false}) public form: DynamicFormComponent;

  @ViewChild('confirmModal', {static: false}) public confirmModal: ModalDirective;
  @ViewChild('rejectModal', {static: false}) public rejectModal: ModalDirective;
  @ViewChild(ApproveClientUploadRowComponent, {static: false}) ApproveClientUploadRowComponent;

  public submiting: boolean = false;
  public viewRole: any;

  constructor(
    public gridService: NotificationBuilderService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: FormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'notificationBuilder');
    let params = this.route.snapshot.queryParamMap.get('status');
    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe((langId) => {
      this.loadVisuals();
      this.getValidationMessages();
    });

    this.checkboxPK = 'cookieid';
  }

  getCheckboxCallback() {
    this.checkboxPKArray = [];
    this.checkboxPKArrayFull = [];
    this.gridService.getPKs(this.dataCountParams()).subscribe(
      (data) => {
        this.checkboxPKArrayFull = data.data;
      },
      (error) => {
        return throwError(error);
      },
    );
  }
  public rowClick(params) {
    const {eventType, iLangId, mediaType} = params;
    const queryParams = {
      eventType,
      iLangId,
      mediaType,
    };

    this.route.queryParams.subscribe((existingParams) => {
      const updatedParams = {...existingParams, ...queryParams};
      this.router.navigate(['/menu/7701'], {
        queryParams: updatedParams,
      });
    });
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {
    if (event.modalname == 'debtorModal') {
      this.form.setValue('debtorId', event.value.dbtrId);
    }
  }

  afterFormInit(formConfig: any) {
    let params = this.route.snapshot.queryParamMap.get('status');
    let notificationId = this.route.snapshot.queryParamMap.get('notificationId');
    let hasUrlParamKey =
      this.route.snapshot.queryParams.hasOwnProperty('status') ||
      this.route.snapshot.queryParams.hasOwnProperty('notificationId');
    if (this.form && this.form.controls.length > 0 && hasUrlParamKey) {
      this.form.setValue('invStatusFull', params);
      this.form.setValue('notificationId', notificationId);
      this.submit(this.form.value);
    }
  }

  public confirmApprove() {
    this.submiting = true;
    this.gridService.approve(this.checkboxPKArray).subscribe(
      (data) => {
        console.log(data);
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.confirmModal.hide();
        this.submiting = false;
        this.search();
      },
      (error) => {
        this.submiting = false;
        this.confirmModal.hide();
        this.search();
        return throwError(error);
      },
    );
  }
  public confirmReject() {
    this.submiting = true;
    this.gridService.reject(this.checkboxPKArray).subscribe(
      (data) => {
        console.log(data);
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.rejectModal.hide();
        this.submiting = false;
        this.search();
      },
      (error) => {
        this.submiting = false;
        this.rejectModal.hide();
        this.search();
        return throwError(error);
      },
    );
  }

  public initiateApprove(params) {
    this.confirmModal.show();
  }
  public initiateReject(params) {
    this.rejectModal.show();
  }

  public cookieInput;

  public rowModal(params) {
    this.cookieInput = params['cookieid'];

    this.ApproveClientUploadRowComponent.ngOnChanges({
      id: {currentValue: this.cookieInput},
    });

    this.ApproveClientUploadRowComponent.showChildModal();
  }
}
